import { gql } from '@apollo/client';

export const PUBLISH_JOB_AD_BOOKING_EVENT = gql`
  mutation PublishJobAdBookingEvent($input: PublishJobAdBookingEventInput!) {
    publishJobAdBookingEvent(input: $input) {
      published
    }
  }
`;
